import { createSelector } from 'reselect';

import { RootState } from 'store/types';

import { PricerState } from './pricerReducer';

const selectPricerState = (state: RootState) => state.pricer;

export const selectTransactionId = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.transaction_id,
);
export const selectGetTransactionFailed = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.getTransactionFailed,
);
export const selectTransactionLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transactionLoading,
);
export const selectPricerType = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.pricerType,
);
export const selectHedgingInstrument = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.hedgingInstrument,
);
export const selectTransactionLegs = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.legs,
);
export const selectTransactionTradeSummary = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.trade_summary,
);
export const selectTransactionOption = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.option,
);
export const selectTransactionAveragingOption = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.fx_averaging,
);
export const selectTransactionExecutionCriteria = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.execution_criteria,
);
export const selectTransactionDealContingent = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.deal_contingent,
);
export const selectIsDealContingent = createSelector(
  selectPricerState,
  (pricerState: PricerState) =>
    !!pricerState.transaction.trade_summary.is_deal_contingent,
);
export const selectBuildScheduleLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.buildScheduleLoading,
);
export const selectSaveTradeLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.saveTradeLoading,
);
export const selectValueTradeLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.valueTradeLoading,
);
export const selectValuationDate = createSelector(
  selectPricerState,
  (pricerState: PricerState) =>
    pricerState.transaction.valuationDates.valuation_date,
);
export const selectCurveDate = createSelector(
  selectPricerState,
  (pricerState: PricerState) =>
    pricerState.transaction.valuationDates.curve_date,
);
export const selectTransactionValuation = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.transaction_valuation,
);
export const selectTransactionMetrics = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.transaction_metrics,
);
export const selectTransactionLegValuation = createSelector(
  selectPricerState,
  (pricerState: PricerState) =>
    pricerState.transaction.transaction_leg_valuation,
);
export const selectSeparateLegValuationMode = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.separateLegValuationMode,
);
export const selectFilesForDownloadLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.filesForDownloadLoading,
);
export const selectReviewTradeLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.reviewTradeLoading,
);
export const selectFilesForDownload = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.filesForDownload,
);
export const selectApprovalRequest = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.approval_request,
);
export const selectFXSpot = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.options.spot.data,
);
export const selectFXSpotLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.options.spot.loading,
);
export const selectFXForward = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.options.forward.data,
);
export const selectFXForwardLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.options.forward.loading,
);
export const selectFXRateLocker = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.options.fxRateLocker,
);
export const selectPercentage = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transaction.percentage,
);

export const selectTransactionRelationships = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transactionRelationships,
);
export const selectTransactionRelationshipsLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transactionRelationshipsLoading,
);
export const selectSaveTransactionRelationshipLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.saveTransactionRelationshipLoading,
);
export const selectTransactionRelationshipTypes = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transactionRelationshipTypes,
);
export const selectTransactionRelationshipTypesLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) => pricerState.transactionRelationshipTypesLoading,
);
export const selectSaveTransactionRelationshipTypeLoading = createSelector(
  selectPricerState,
  (pricerState: PricerState) =>
    pricerState.saveTransactionRelationshipTypeLoading,
);
